<template>
    <div :class="[{'px-0': $vuetify.breakpoint.xsOnly},
                  {'px-0': $vuetify.breakpoint.smAndUp},
                  'cont pb-3 grey lighten-4']">
        <v-card-title class="px-5 white">
            <span v-if="isSpielFremdAdmin">Vereinsfremde Spiele</span>
            <span v-else-if="lv">{{lvId}}{{vereinId}} / {{verein.name}}</span>
            <span v-else>Spielberichte verwalten</span>
        </v-card-title>
        <v-card-subtitle class="px-5 pb-2 white">
            <span v-if="lv || user.uid">Spielberichte verwalten</span>
            <span v-else>Du bist nicht angemeldet oder hast keine Berchtigung zur Verwaltung von Spielberichten!</span>
        </v-card-subtitle>
        <!--<v-card class="grey" >-->
        <div v-if="user.permissions.spielbericht || (user.uid && isSpielFremdAdmin)">
            <v-tabs grow v-model="tab" class="ml-0 pl-0 grey">
                <v-tab>
                    <v-icon class="mr-1">mdi-alert-box</v-icon>Offen
                    <span v-if="$vuetify.breakpoint.smAndUp">e Spielberichte</span>
                </v-tab>
                <v-tab>
                    <v-icon class="mr-1">mdi-check</v-icon>Erledigt
                    <span v-if="$vuetify.breakpoint.smAndUp">e Spielberichte</span>
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab" class="grey lighten-4" touchless>
                <v-tab-item>
                    <spiel-berichte-offen :is-spiel-fremd-admin="isSpielFremdAdmin"/>
                </v-tab-item>
                <v-tab-item>
                    <spiel-berichte-erledigt></spiel-berichte-erledigt>
                </v-tab-item>
            </v-tabs-items>
        </div>
        <div v-else>
            <v-btn color="secondary" class="my-5 ml-5" @click="login()">
                <v-icon class="mr-2">mdi-login</v-icon>
                Anmelden</v-btn>
            <v-btn color="secondary" class="ml-5"
                   @click="navigate('Ergebnisdienst')">
                <v-icon class="mr-2">mdi-arrow-left</v-icon>
                Zurück zum Ergebnisdienst</v-btn>
        </div>
        <v-btn v-if="$vuetify.breakpoint.smAndDown" fab dark bottom right
               color="primary" style="position: fixed; right: 15px; bottom: 15px; z-index: 15" @click="back()">
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <!--</v-card>-->
    </div>
</template>

<script>
    import SpielBerichteOffen from "./spielBerichteOffen";
    import SpielBerichteErledigt from "./spielBerichteErledigt";
    import SpielService from "../../../services/data/spielService";

    export default {
        components: {
            SpielBerichteErledigt,
            SpielBerichteOffen},
        name: "spiel-berichte",
        computed: {
            user(){ return this.$store.state.user; },
            lvId(){ return this.user.permissions.spielbericht ?
                            SpielService.getLvIdFromVereinsNrLong( this.user.permissions.spielbericht) : null ; },
            lv(){ return this.lvId ?
                         this.$store.state.realtime.landesverbaende[this.lvId] : null; },
            vereinId(){return this.lv ?
                            SpielService.getVereinsNrFromVereinsNrLong(this.user.permissions.spielbericht) : null; },
            verein(){return this.vereinId && this.lv.vereine ?
                            this.lv.vereine[this.vereinId] : { name: ''} ; },
            isSpielFremdAdmin(){ return this.$route.path === '/Ergebnisdienst/SpielberichteFremd'},
            path(){ return this.$route.path},
        },
        data: () => ({
            tab: 0,
        }),
        created(){
            this.init()
        },
        methods: {
            init(){
                if ( this.$route.query.action ) {
                    let p = JSON.parse(JSON.stringify(this.$route.path));
                    let q = JSON.parse(JSON.stringify(this.$route.query));
                    delete q.action;
                    this.$router.replace({path: p, query: q});
                }
                this.bindLandesverband();
            },
            login(){
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.login = true;
                this.$router.push({path: p, query: q});
            },
            navigate(target){
                this.$router.push({path: '/' + target});
            },
            bindLandesverband(){
                console.log ("METHOD BIND ", this.lvId, this.lv );
                if ( this.lvId && !this.lv && !this.isSpielFremdAdmin ) {
                    console.log ("BIND IS PERFORMED");
                    this.$store.dispatch('bindRealtimeDocument', {
                        collection: 'landesverbaende',
                        docId: this.lvId,
                        storeField: 'landesverbaende.' + this.lvId,
                    });
                }
            // bind all for spiel fremd admin
                if ( this.isSpielFremdAdmin ) {
                    for (let i = 11; i < 20; i++) {
                        this.$store.dispatch('bindRealtimeDocument', {
                            collection: 'landesverbaende',
                            docId: i.toString(),
                            storeField: 'landesverbaende.' + i,
                        });
                    }
                }
            // bind always for bundesliga
                if ( !this.$store.state.realtime.landesverbaende['1'] ) {
                    this.$store.dispatch('bindRealtimeDocument', {
                        collection: 'landesverbaende',
                        docId: '1',
                        storeField: 'landesverbaende.1',
                    });
                }
            },
            back(){
                window.history.back();
            }
        },
        watch: {
            lvId(){
                this.bindLandesverband();
            },
            path(){
                this.init()
            }
        }
    }
</script>

<style scoped>
    .cont {position: fixed; top: 48px; bottom: 0; left: 0; right: 0;
            width: 100%; overflow-y: auto}
</style>